import type { SelfOwnedWidgetDefinition } from '../WidgetDefinition';
import { faTable } from '@fortawesome/pro-regular-svg-icons/faTable';
import type { ResultsWidgetModel, ResultsWidgetState } from 'src/models/ResultsWidgetModel';
import { ResultsWidgetModelImpl } from 'src/models/ResultsWidgetModel/impl';

export const resultsWidgetDefinition: SelfOwnedWidgetDefinition<ResultsWidgetState, ResultsWidgetModel> = {
    type: 'results' as const,
    nameKey: 'widgets::results::name' as const,
    roles: ['widgets::results'],
    icon: faTable,
    category: 'widgets::categories::research' as const,
    widgetClass: ResultsWidgetModelImpl,
};
